module.exports = __webpack_public_path__ + "img/cut_sx2.9e5c6d3f.png";